// extracted by mini-css-extract-plugin
export default {"dashboardPage":"Dashboard_dashboardPage__wku5n"};